import React, {createContext, PropsWithChildren, useCallback, useMemo, useState} from 'react';
import {noop} from 'lodash';
import {EDSApplication} from '@ellucian/react-design-system/core';
import classNames from 'classnames';

import useFeatureFlags from 'src/hooks/useFeatureFlags';

import './path-design-context.scss';

type EllucianCtaColors = 'blue' | 'green' | 'iris' | 'plum' | 'taupe';

interface PathDesign {
  enabled: boolean;
  theme: EllucianCtaColors;
  changeTheme: (theme: EllucianCtaColors) => void;
}

export const PathDesignContext = createContext<PathDesign>({
  enabled: false,
  theme: 'blue',
  changeTheme: noop,
});

const PathDesignProvider = ({children}: PropsWithChildren) => {
  const flags = useFeatureFlags(['path_design']);
  const [theme, setTheme] = useState<EllucianCtaColors>('blue');

  const changeTheme = useCallback((newTheme: EllucianCtaColors) => {
    setTheme(newTheme);
  }, []);

  const value = useMemo(
    () => ({enabled: flags.pathDesign, theme, changeTheme}),
    [flags.pathDesign, theme, changeTheme]
  );

  return (
    <PathDesignContext.Provider value={value}>
      {flags.pathDesign ? (
        <EDSApplication>
          <div className={classNames('shared-path-design', `--${theme}`)}>{children}</div>
        </EDSApplication>
      ) : (
        children
      )}
    </PathDesignContext.Provider>
  );
};

export default PathDesignProvider;
